import { BlogPostFormData } from '~/shared/api/services/blog-posts/types'
import { EditorSeoData } from './editor'

export const createInitialFormData = (): BlogPostFormData => {
  return {
    storeId: '',
    slug: '',
    previewId: null,
    publishAt: null,
    tags: [],
    title: '',
    description: '',
    content: '',
    keywords: '',
  }
}

export const createInitialEditorSeo = (): EditorSeoData => {
  return {
    storeId: null,
    tagIds: [],
    slug: '',
  }
}
